/*重构登陆接口功能*/
import axios from "../index";
import api from "./login.api";

export default {
  /**
   * 登陆 @data loginName:用户名 ;pwd用户密码
   */
  login(data = {}) {
    return axios.post(api.login, data);
  },
  /**
   * 查询当前账号下我的模型列表  @data "userId":用户id
   */
  loginOut(data = {}) {
    return axios.post(api.loginOut, data);
  },
  /**
   * 获取用户所属的租户列表  @data
   */
  getUserTenantList(data = {}) {
    return axios.post(api.getUserTenantList, data);
  },
  /**
   * 获取用户上次选择的租户  @data
   */
  getLastTimeTenant(data = {}) {
    return axios.post(api.getLastTimeTenant, data);
  },
  /**
   * 记录切换租户行为  @data {
     "behaviorId": "上次操作的行为id",
     "tenantId": 切换后的租户id,
     "tenantName": "切换后的租户名称"
   }
   */
  updateTenantBehavior(data = {}) {
    return axios.post(api.updateTenantBehavior, data);
  },
  /**
   * 通过租户id查询菜单列表  @data {"tenantId": 租户Id}
   */
   getMenuListByTenantId(data = {}) {
    return axios.post(api.getMenuListByTenantId, data);
  },
};
